"use client";

import { c as _c } from "react/compiler-runtime";
import { EASE_OUT_QUART, MOTION_DURATION } from "@/lib/animation-constants";
import { motion, useReducedMotion } from "motion/react";

/**
 * Centered B3OS logo with a gradient horizontal rule behind it. Matches the
 * Figma hero (node 2202:9167). Logo asset is the full embossed circle; rule
 * is an inline SVG with a transparent→neutral→transparent linear gradient.
 */
export function DashboardHeroLogo(t0) {
  const $ = _c(23);
  const {
    delay: t1
  } = t0;
  const delay = t1 === undefined ? 0 : t1;
  const shouldReduceMotion = useReducedMotion();
  let t2;
  if ($[0] !== delay || $[1] !== shouldReduceMotion) {
    t2 = shouldReduceMotion ? {
      duration: 0
    } : {
      duration: MOTION_DURATION.page + 0.24,
      delay,
      ease: EASE_OUT_QUART
    };
    $[0] = delay;
    $[1] = shouldReduceMotion;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const lineTransition = t2;
  let t3;
  if ($[3] !== delay || $[4] !== shouldReduceMotion) {
    t3 = shouldReduceMotion ? {
      duration: 0
    } : {
      duration: MOTION_DURATION.slow + 0.06,
      delay: delay + 0.04,
      ease: EASE_OUT_QUART
    };
    $[3] = delay;
    $[4] = shouldReduceMotion;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const markTransition = t3;
  let t4;
  if ($[6] !== shouldReduceMotion) {
    t4 = shouldReduceMotion ? false : {
      scaleX: 0,
      opacity: 0
    };
    $[6] = shouldReduceMotion;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      scaleX: 1,
      opacity: 1
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M0.5 0.5H700.5" stroke="url(#dashboard-hero-rule)" strokeLinecap="round" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <defs><linearGradient id="dashboard-hero-rule" x1="0.5" y1="1" x2="700.5" y2="1" gradientUnits="userSpaceOnUse"><stop stopColor="white" stopOpacity="0" /><stop offset="0.2" stopColor="var(--ds-neutral-200)" /><stop offset="0.5" stopColor="var(--ds-neutral-200)" /><stop offset="0.8" stopColor="var(--ds-neutral-200)" /><stop offset="1" stopColor="white" stopOpacity="0" /></linearGradient></defs>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== lineTransition || $[12] !== t4) {
    t8 = <div className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"><motion.svg aria-hidden={true} xmlns="http://www.w3.org/2000/svg" width="701" height="1" viewBox="0 0 701 1" fill="none" className="block" initial={t4} animate={t5} transition={lineTransition}>{t6}{t7}</motion.svg></div>;
    $[11] = lineTransition;
    $[12] = t4;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== shouldReduceMotion) {
    t9 = shouldReduceMotion ? false : {
      opacity: 0,
      scale: 0.9
    };
    $[14] = shouldReduceMotion;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      opacity: 1,
      scale: 1
    };
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== markTransition || $[18] !== t9) {
    t11 = <motion.img src="https://cdn.b3.fun/b3os-rounded-circle-logo-embossed.svg" alt="B3OS" className="relative size-[151px]" initial={t9} animate={t10} transition={markTransition} />;
    $[17] = markTransition;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t8) {
    t12 = <div className="relative flex h-[151px] w-full items-center justify-center">{t8}{t11}</div>;
    $[20] = t11;
    $[21] = t8;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
}